var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93055 22.75C4.51055 22.75 4.12055 22.65 3.77055 22.45C3.00055 22 2.56055 21.09 2.56055 19.96V5.86C2.56055 3.32 4.63055 1.25 7.17055 1.25H16.8205C19.3605 1.25 21.4305 3.32 21.4305 5.86V19.95C21.4305 21.08 20.9905 21.99 20.2205 22.44C19.4505 22.89 18.4405 22.84 17.4505 22.29L12.5705 19.58C12.2805 19.42 11.7105 19.42 11.4205 19.58L6.54055 22.29C6.00055 22.59 5.45055 22.75 4.93055 22.75ZM7.18055 2.75C5.47055 2.75 4.07055 4.15 4.07055 5.86V19.95C4.07055 20.54 4.24055 20.98 4.54055 21.15C4.84055 21.32 5.31055 21.27 5.82055 20.98L10.7005 18.27C11.4405 17.86 12.5605 17.86 13.3005 18.27L18.1805 20.98C18.6905 21.27 19.1605 21.33 19.4605 21.15C19.7605 20.97 19.9305 20.53 19.9305 19.95V5.86C19.9305 4.15 18.5305 2.75 16.8205 2.75H7.18055Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.d73ba0915e90ffc314d4b1e02ab9f0e9.svg";
export { ForwardRef as ReactComponent };